export const GUEST_LAYOUT = "/";

export const HOME = "/";

export const LOGIN_PATH = "/login";

export const FORGOT_PASSWORD_PATH = "/forgot-password";

export const RESET_PASSWORD_PATH = "/reset-password";
